import { Outlet } from "react-router-dom";
import { MasterFooter } from "../MasterFooter/MasterFooter";
import { MasterHeader } from "../MasterHeader/MasterHeader";
import style from "./masterLayout.module.scss";

export const MasterLayout = () => {
  return (
    <main className="h-full w-full overflow-y-auto flex flex-col relative ">
      <MasterHeader />

      <article className={`${style.content} flex-grow p-4 overflow-hidden`}>
        <Outlet />
      </article>

      <div className="">
        <MasterFooter />
      </div>
    </main>
  );
};
